import { Button, Nav } from 'react-bootstrap';
import React, { useEffect, useState, useRef } from 'react';

import CreateLeadForm from '../../components/CreateLeadForm';
import { getLabel } from '../../lib/labels';
import { useSelector } from 'react-redux';
import selectors from '../../selectors/selectors.js';
import setQuery from '../../lib/setQuery.js';
import Slider from '../../components/Slider.js';
import SVG from '../../images/svg/SVG.js';

const CreateLeadModal = () => {
  const creatingLead = useSelector(selectors.creatingLead);
  const creatingLeadRef = useRef(creatingLead);

  const [showModal, setShowModal] = useState(false);

  const openModal = (e) => {
    setQuery({
      modal: null,
      eid: null,
      lead: null,
      view: null,
      pipelineLeadId: null,
      statusId: null,
      creating: null,
      todoId: null,
      contactId: null,
      noteId: null,
      etype: null,
    });
    setShowModal(true);
  };

  useEffect(() => {
    creatingLeadRef.current = creatingLead;
  }, [creatingLead]);

  useEffect(() => {
    if (showModal && !creatingLead) {
      setQuery({ creatingLead: true });
    }
    if (!showModal && creatingLeadRef.current) {
      setQuery({ creatingLead: null });
    }
  }, [showModal]);

  useEffect(() => {
    if (!creatingLead) {
      handleCreateLeadFormClose();
    }
  }, [creatingLead]);

  const handleCreateLeadFormClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Nav.Item>
        <Button onClick={openModal} className={'btn btn-primary'}>
          <SVG icon={'Add'} basic={true} invert={true} />
          New {getLabel('leads', false, true)}
        </Button>
      </Nav.Item>
      <Slider show={showModal} onHide={handleCreateLeadFormClose} classes={'create-lead-modal'}>
        <div className={'pane-header'}>
          <h1 className={'heading'}>New Customer</h1>
        </div>
        <div className="pane-content create-lead-modal">{showModal && <CreateLeadForm onClose={handleCreateLeadFormClose} modalView={true} />}</div>
      </Slider>
    </>
  );
};

export default CreateLeadModal;
